/**
 * Ory APIs
 *
 * Contact: support@ory.sh
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CreateWorkspaceSubscriptionBody { 
    /**
     *  usd USD eur Euro
     */
    currency?: CreateWorkspaceSubscriptionBody.CurrencyEnum;
    /**
     *  monthly Monthly yearly Yearly
     */
    interval: CreateWorkspaceSubscriptionBody.IntervalEnum;
    plan: string;
    return_to?: string;
}
export namespace CreateWorkspaceSubscriptionBody {
    export type CurrencyEnum = 'usd' | 'eur';
    export const CurrencyEnum = {
        Usd: 'usd' as CurrencyEnum,
        Eur: 'eur' as CurrencyEnum
    };
    export type IntervalEnum = 'monthly' | 'yearly';
    export const IntervalEnum = {
        Monthly: 'monthly' as IntervalEnum,
        Yearly: 'yearly' as IntervalEnum
    };
}


